import React from 'react';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import Typography from '@mui/joy/Typography';
import { Button, Card, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/joy';

export default function ParentCoursePopup({
    open = false,
    onClose = () => { },
    courseData = {},
}) {
courseData = courseData.current || {};
    return (
        <Modal open={open} onClose={onClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} disableScrollLock={true}>
            <ModalDialog sx={{ opacity: open ? 1 : 0, transition: `opacity 300ms` }}>
                <DialogTitle>Course Details</DialogTitle>
                <DialogContent>
                    <Stack
                        direction="row"
                        spacing={1}
                        sx={{
                            justifyContent: "flex-center",
                            alignItems: "flex-start",
                            overflowX: 'auto',
                            flexWrap: 'nowrap',
                            py: 1,
                            '& > *': {
                                flex: '0 0 auto',
                                maxWidth: 'none',
                                boxSizing: 'border-box',
                            },
                            '& > *:not(:last-child)': {
                                pr: 1,
                            },
                            '&::-webkit-scrollbar': { height: 8 },
                            '&::-webkit-scrollbar-thumb': { background: 'rgba(0,0,0,0.2)', borderRadius: 4 },
                        }}>


                        <Card size="md" variant="soft" key={courseData.crsId} sx={{ minWidth: 450, maxWidth: 450, p: 2 }}>
                            <Typography level="h4" sx={{ color: "#016799" }}>{courseData.crsId}</Typography>
                            <Typography level="h4" sx={{ color: "#016799" }}>{courseData.title}</Typography>
                            <Typography level="body-xs" sx={{ mb: 2 }}>{courseData.description}</Typography>
                            <Typography level="body-sm" sx={{ mr: 'auto', ml: 1 }}>
                                Validity{' - '}
                                <Typography textColor="text.tertiary" sx={{ fontSize: 'sm' }}>
                                    {(courseData.validity?.years === 0 && courseData.validity?.months === 0) ? (
                                        <>No expiry</>

                                    ) : courseData.validity?.years > 0 ? (

                                        courseData.validity?.months > 0 ?
                                            <>{courseData.validity?.years + " yr " + courseData.validity?.months + " months"}</>

                                            :
                                            <>{courseData.validity?.years + " years"}</>
                                    ) : (
                                        <>{courseData.validity?.months + " months"}</>
                                    )

                                    }
                                </Typography>
                            </Typography>

                        </Card>

                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant="plain" color="neutral" onClick={() => onClose()}>
                    Dismiss
                    </Button>
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}